module.exports = __webpack_public_path__ + "static/media/Calculator.ec8f5ac3.svg";